import { render, staticRenderFns } from "./NationalExamRegistrationSelect.vue?vue&type=template&id=d646c870&scoped=true&"
import script from "./NationalExamRegistrationSelect.vue?vue&type=script&lang=js&"
export * from "./NationalExamRegistrationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d646c870",
  null
  
)

export default component.exports